<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >

  

  <b-modal 
    v-if="hasActivePopup"
    v-model="showPopup"
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          @hidden="handlePopupHidden"
          >
          <Template v-if="showDevis !== null" :__object="showDevis"></Template>
          <Manager
            ref="cmdManager"
            v-if="showManagerItem !== null"
            :__item="showManagerItem"
            :__admin="admin"
            :__userList="[]"
            :__isSingelton="true"
            :__isSaving="onGoingReq.length > 0"
            :__onSave="onSave"
          ></Manager>
  </b-modal>
  <div class="row pageHeader" v-if="!isLightMode">
  <div class="row subMenu">
    <b-button size="sm" variant="danger" style="float: right; margin: 5px" :class="{ activeFilterButton: showFilter }" @click.stop="toggleFilterPanel()">Filtrer</b-button>
  </div>

    <FilterDrawerShell
      :show="showFilter"
      title="Filtres devis"
      :count="filtredListitems.length"
      @close="closeFilterPanel"
    >
      <template #sorts>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isDate.state)" icon="check-square-fill" @click="sortFiltre.isDate.state = !sortFiltre.isDate.state"></b-icon>
          <span>Date</span>
          <b-icon class="redColor" v-if="sortFiltre.isDate.state" icon="recycle" @click="sortFiltre.isDate.isUp = !sortFiltre.isDate.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isName.state)" icon="check-square-fill" @click="sortFiltre.isName.state = !sortFiltre.isName.state"></b-icon>
          <span>Nom</span>
          <b-icon class="redColor" v-if="sortFiltre.isName.state" icon="recycle" @click="sortFiltre.isName.isUp = !sortFiltre.isName.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isActivated.state)" icon="check-square-fill" @click="sortFiltre.isActivated.state = !sortFiltre.isActivated.state"></b-icon>
          <span>Etat</span>
          <b-icon class="redColor" v-if="sortFiltre.isActivated.state" icon="recycle" @click="sortFiltre.isActivated.isUp = !sortFiltre.isActivated.isUp"></b-icon>
        </div>
      </template>

      <div class="filterField">
        <label>Société</label>
        <base-input
          placeholder="Société"
          v-model="filterContainer.keySearchSte"
          type="string"
        >
        </base-input>
      </div>
      <div class="filterField">
        <label>Exercice</label>
        <b-form-select
          v-model="filterContainer.filterExercice"
          :options="exerciceOptions"
          @change="handleExerciceChange"
        ></b-form-select>
      </div>
    </FilterDrawerShell>
  </div>

    <div :class="getMainPanel">

      <div
        :class="styleSublisteMode"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style="getState(item.status)"
        v-if="isLightMode"
      >
        <div class="recordLightCard">
          <div class="recordLightIdentity">
            <div class="recordLightRef">{{ item.type }} N° {{item.num}} / {{item.exercice}}</div>
            <div class="recordLightMeta">{{ item.owner && item.owner.name ? item.owner.name : 'Client' }}</div>
          </div>
          <div class="recordLightAmount">
            <span>TTC</span>
            <b>{{ formatMoney(item.totalTTC) }}</b>
          </div>
          <div class="recordLightActions">
            <b-button size="sm" variant="danger" @click="setReject(item)" v-if="['NOUVEAU'].includes(item.status)">Annuler</b-button>
            <b-button size="sm" variant="success" @click="setTermine(item)" v-if="item.status === 'NOUVEAU'">Commander</b-button>
            <b-button size="sm" variant="info" @click="showDevis = item;showPopup=true ">Voir</b-button>
          </div>
        </div>
      </div>


      <div
        :class="styleSublisteMode"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style="getState(item.status)"
        v-if="!isLightMode"
      >
        <div class="recordCard">
          <div class="recordCardTop">
            <div class="recordCardIdentity">
              <div class="recordCardNumber">N° {{item.num}} / {{item.exercice}}</div>
              <div class="recordCardType">{{ item.type }}</div>
            </div>

            <div class="recordCardClient">
              <div class="recordCardDate">{{ __._getDate(item.createdAt) }}</div>
              <div class="recordCardOwner">{{ item.owner && item.owner.name ? item.owner.name : 'Client non renseigné' }}</div>
            </div>

            <div class="recordCardAmount">
              <span class="recordCardAmountLabel">Montant TTC</span>
              <b class="recordCardAmountValue">{{ formatMoney(item.totalTTC) }}</b>
            </div>
          </div>

          <div class="recordCardBody">
            <div class="recordInfoBlock">
              <div class="recordInfoLabel">Articles</div>
              <div class="recordArticlesList" v-if="item.devis && item.devis.length">
                <div v-for="(article, idx) in item.devis" :key="idx" class="recordArticleRow">
                  <span class="recordArticleQty">{{ article.qte }}</span>
                  <span class="recordArticleRef">{{ article.ref }}</span>
                  <span class="recordArticleName">{{ article.name }}</span>
                </div>
              </div>
              <div class="recordEmptyText" v-else>Aucune ligne devis.</div>
            </div>

            <div class="recordInfoBlock">
              <div class="recordInfoLabel">Commandes liées</div>
              <div class="recordLinkedList devisList">
                <Listcmds :isLightMode="true" :PID="item._id" :ref="'cmd'+item._id"></Listcmds>
              </div>
            </div>
          </div>

          <div class="recordCardBottom">
            <div class="recordNotif" v-if="item.notif">{{item.notif}}</div>
            <div class="recordActions">
              <b-button size="sm" variant="danger" @click="setReject(item)" v-if="['NOUVEAU'].includes(item.status)">Annuler le devis</b-button>
              <b-button size="sm" variant="success" @click="showDevis = item;showPopup=true ">Voir le devis</b-button>
              <b-button size="sm" variant="info" @click="setTermine(item)" v-if="item.status === 'NOUVEAU'">Commander</b-button>
              <ico-btn
                v-if="canDeleteItem(item)"
                size="p"
                type="warning"
                icone="trash"
                title="Supprimer"
                :cb="
                  () => {
                    dispatchDelete(item._id);
                  }
                "
              ></ico-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Vue from "vue";
import Template from "@/pages/commun/Template";
import Manager from "@/pages/commun/Manager";
import Listcmds from '@/pages/cmds/index';
import FilterDrawerShell from "@/components/FilterDrawerShell.vue";
export default {
  components: {
    Template,
    Manager,
    Listcmds,
    FilterDrawerShell
  },
  props: {
    isLightMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },

  },

  data() {
    return {
      filterContainer: { keySearchSte: "", filterExercice: "" },
      structure: {},
      showPopup:null,
      showFilter: false,
      admin: null,
      filtredListitems: [],
      showDevis: null,
      showManagerItem: null,
      sourceItemForSave: null,
      onGoingReq:[],
      sortFiltre: {
        isDate: {state: false, isUp: true },
        isName:  {state: false, isUp: true },
        isActivated:  {state: false, isUp: true },
      }
    };
  },
  methods: {
    handleExerciceChange() {
      const archive = String(this.filterContainer.filterExercice || "").trim();

      if (!archive) {
        return;
      }

      Vue.$cookies.set("exercice", archive);
      this.$root.$emit("archive:changed", archive);
      this.$parent.loadData();
    },

    normalizeNum(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    getLastDocumentId() {
      if (!Array.isArray(this.__list) || this.__list.length === 0) {
        return null;
      }

      const latestDocument = this.__list.reduce((selected, document) => {
        if (!document) {
          return selected;
        }

        if (!selected) {
          return document;
        }

        const currentNum = this.normalizeNum(document.num);
        const selectedNum = this.normalizeNum(selected.num);

        if (currentNum > selectedNum) {
          return document;
        }

        if (currentNum < selectedNum) {
          return selected;
        }

        const currentDate = new Date(document.createdAt || 0).getTime();
        const selectedDate = new Date(selected.createdAt || 0).getTime();

        return currentDate >= selectedDate ? document : selected;
      }, null);

      return latestDocument ? latestDocument._id : null;
    },

    isLastDocument(item) {
      return Boolean(item && item._id && item._id === this.getLastDocumentId());
    },

    canDeleteItem(item) {
      return !this.isLightMode && this.isEditable(item) && this.isLastDocument(item);
    },

    toggleFilterPanel() {
      this.showFilter = !this.showFilter;
    },

    closeFilterPanel() {
      this.showFilter = false;
    },

    dispatchDelete(idx) {
      this.$bvModal
        .msgBoxConfirm("Veuillez confirmer la suppression.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.deleteAction(idx);
          }
        });
    },

    resetPopupState() {
      this.showDevis = null;
      this.showManagerItem = null;
      this.sourceItemForSave = null;
    },

    handlePopupHidden() {
      this.showPopup = false;
      this.resetPopupState();
    },


    isEditable(item) {
      if (!this.admin) {
        return false
      }

      if(['ROOT','ADMIN'].includes(this.admin.type)) {
        return true
      } 
      if(['COMMERCIAL'].includes(this.admin.type)) {
        return item.assignedToID === this.admin._id
      } 
      return false
    },

    filtredList() {
      var ret = Array.isArray(this.__list) ? [...this.__list] : [];

      if (this.filterContainer.keySearchSte)
        ret = ret.filter((e) =>
        e.owner && e.owner.name && e.owner.name.includes(this.filterContainer.keySearchSte) 
        );

    
        if(this.sortFiltre.isDate.state === true) {
        if(this.sortFiltre.isDate.isUp)
          ret = ret.sort((a, b) => (new Date(a.createdAt)).getTime() - (new Date(b.createdAt)).getTime());
        else
        ret = ret.sort((a, b) => (new Date(b.createdAt)).getTime() - (new Date(a.createdAt)).getTime());
      }

        
      if(this.sortFiltre.isName.state === true) {
        if(this.sortFiltre.isName.isUp)
          ret = ret.sort((a, b) => String((a.owner && a.owner.name) || "").localeCompare(String((b.owner && b.owner.name) || "")));
        else
          ret = ret.sort((a, b) => String((b.owner && b.owner.name) || "").localeCompare(String((a.owner && a.owner.name) || "")));
      }



      if(this.sortFiltre.isActivated.state === true) {
        
        if(this.sortFiltre.isActivated.isUp)
        ret = ret.sort((a, b) => String(a.status).localeCompare(String(b.status)));
        else
          ret = ret.sort((a, b) => String(b.status).localeCompare(String(a.status)));
      }
      
      this.filtredListitems = ret.filter(e => e.name !== '');
      //return ret;
    },
    
    createCmd(item, onSuccess = null) {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        const payload = response && response.data ? response.data : {};
        const cmd = payload.cmd || null;

        if (payload.isExisting === true && cmd) {
          this.$bvToast.toast(
            "Une commande existe déjà pour ce devis.",
            {
              title: "Génération de commande",
              variant: "warning",
              solid: true,
            }
          );
        }

        if (payload.isExisting === false && cmd) {
          this.resetPopupState();
          this.showManagerItem = cmd;
          this.sourceItemForSave = item;
          this.showPopup = true;
        }

        if (onSuccess && payload.isExisting === true) {
          onSuccess(payload);
        }
      };

      const $onError = () => {
        this.$bvToast.toast(
          "La commande n'a pas pu être générée. Veuillez réessayer.",
          {
            title: "Génération de commande",
            variant: "danger",
            solid: true,
          }
        );
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      this.__.httpAction({
        methode: 'POST',
        route: '/cmds/setfromdevis/' + item._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    onSave() {
      if (this.onGoingReq.length > 0 || !this.showManagerItem || !this.sourceItemForSave) {
        return;
      }

      this.onGoingReq.push({});
      const sourceItem = this.sourceItemForSave;
      const data = this.showManagerItem;
      let $onNext = () => {
        if (this.$refs['cmd'+sourceItem._id] && this.$refs['cmd'+sourceItem._id][0]) {
          this.$refs['cmd'+sourceItem._id][0].loadData();
        }
        this.$parent.setUpdateValue(sourceItem._id, 'TERMINE', 'status');
        this.$parent.setUpdateValue(sourceItem._id, 'Commande générée à partir du devis par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
        this.showPopup = false;
      };

      const $onError = () => {
        this.$bvToast.toast(
          "La commande n'a pas pu être enregistrée. Veuillez réessayer.",
          {
            title: "Commande",
            variant: "danger",
            solid: true,
          }
        );
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.__.httpAction({
        methode: 'POST',
        route: '/cmds/',
        data,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    setReject(item) {
      this.$bvModal
        .msgBoxConfirm("Rejeter le devis?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'REJETE', 'status');
            this.$parent.setUpdateValue(item._id, 'Devis annulé par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
          }
        });
    },

    setTermine(item) {
      this.$bvModal
        .msgBoxConfirm("Valider la commande?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.createCmd(item, () => {
              this.$parent.setUpdateValue(item._id, 'TERMINE', 'status');
              this.$parent.setUpdateValue(item._id, 'Commande générée à partir du devis par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
            })
          }
        });
    },

    

    getIsActif(isActif) {
      return isActif === true
        ? ""
        : "redColor";
    },

    getIsActifSort(isActif) {
      return isActif === false
        ? "grayColor"
        : "greenColor";
    },

    formatMoney(value) {
      const amount = Number(value || 0);
      if (!Number.isFinite(amount)) {
        return value;
      }

      return amount.toLocaleString("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      });
    },

    getState(state) {
      switch (state) {
        case 'NOUVEAU':
          return 'border-left: solid 10px #CCC;'
          break;
        case 'ACCEPTE':
          return 'border-left: solid 10px orange;'
          break;
        case 'TERMINE':
          return 'border-left: solid 10px green;'
          break;
        case 'REJETE':
          return 'border-left: solid 10px red'
          break;
        default:
          break;
      }
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {
    exerciceOptions() {
      const currentYear = new Date().getFullYear();
      const options = [currentYear + 1, currentYear, currentYear - 1, currentYear - 2]
        .map((year) => String(year));

      if (this.filterContainer.filterExercice) {
        options.push(String(this.filterContainer.filterExercice));
      }

      return [...new Set(options)].map((year) => ({
        value: year,
        text: year,
      }));
    },

    hasActivePopup() {
      return this.showDevis !== null || this.showManagerItem !== null;
    },

    styleSublisteMode() {
      return (this.$props.isLightMode) ? "lightMode col-md-12" : "listeMode col-md-12";
    },

   

    getMainPanel() {
      return (this.isLightMode) ? "row mainPanelnoFilter" : "row mainPanelWithoutFilter";
    },

    
  },

  mounted() {
    setTimeout(()=>this.filtredList(),400);
    this.admin = Vue.$cookies.get("user");
    this.filterContainer.filterExercice = String(
      Vue.$cookies.get("exercice") || new Date().getFullYear()
    );
  },

  watch: {
    __isOnLoad: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList")
        this.filtredList()
      },
    },

    __list: {
      deep: true,
      handler() {
        this.filtredList();
      },
    },
   
    filterContainer: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },

    sortFiltre: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },
  },
};
</script>
<style scoped>
.redColor {
  color: red
}
.greenColor {
  color: green;
}
.grayColor {
  color: #CCC;
}
.listeMode {
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.lightMode {
  padding: 1%;
  margin-bottom: 12px;
  border-radius: 10px;
  background-color: #F2F2F2;
}

.listeMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.pic {
  width: 17%;
  margin-right: 3%;
  float: left;
}
.pic img {
  border-radius: 50%;
}
.preview {
  float: left;
  font-weight: bolder;
}

.preview em {
  font-weight: lighter;
  font-size: 12px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}
.mainPanelWithoutFilter {
  margin-top: 100px;
}

.mainPanelnoFilter {
  margin-top: 0px;
}

.subMenu {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    background-color: black;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    min-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .pageHeader {
    position: fixed;
    top: 120px;
    left: 0;
    width: 100%;
    z-index:333;
    background: #f2f2f2;
    overflow: visible;
  }
  .pageHeader.row,
  .subMenu.row {
    margin-left: 0;
    margin-right: 0;
  }

  .serachPanel {
    position: fixed;
  top: 119px;
    right: 0;
    width: min(420px, calc(100vw - 36px));
    height: calc(100vh - 148px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
    box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
    border: 1px solid #dbe4f0;
    z-index: 334;
    font-size: 14px;
    animation: filterPanelReveal 0.24s ease;
  }
  .serachPanel.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 0 10px;
  }
  .filterPanelHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #e2e8f0;
  }
  .filterPanelTitle {
    font-size: 21px;
    font-weight: 700;
    color: #0f172a;
  }
  .filterPanelCount {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }
  .filterCloseBtn {
    background: #1f2a44;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    padding: 7px 14px;
  }
  .filterQuickTools {
    padding: 14px !important;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
  border-radius: 0;
    margin-bottom: 8px;
  }
  .filterQuickTitle {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 10px;
    letter-spacing: 0.04em;
  }
  .serachPanel .form-control,
  .serachPanel .custom-select {
    width: 100%;
    min-height: 46px;
    font-size: 15px !important;
    border-radius: 12px;
  }
  .serachPanel [class*="col-"] {
    font-size: 15px;
  }

@keyframes filterPanelReveal {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .pageHeader {
    top: 50px;
  }

  .subMenu {
    padding: 6px 10px;
    justify-content: center;
  }

  .serachPanel {
    top: 119px;
    right: 0;
    width: calc(100vw - 20px);
    height: calc(100vh - 108px);
    padding: 12px;
  }

  .mainPanelWithoutFilter {
    margin-top: 110px;
  }
}
</style>

